module.exports = __webpack_public_path__ + "f99dfef75042d9ee742cedc0964fa979.mp3";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/wauw_rustig.mp3
// module id = 94
// module chunks = 0